
export interface AdvisorAbout {
    title: string;
    content: string;
}

export interface AdvisorLink {
    link: string;
    label: string;
}

export enum AdvisorTypeEnum {
    AAI = 'aai',
    EXCLUSIVE = 'exclusive',
    POTENTIAL = 'potential',
    UNKNOWN = 'unknown',
}

export interface Advisor {
    type: AdvisorTypeEnum;
    name: string;
    email: string;
    phone: string;
    mobilePhone: string;
    profilePictureUrl: string;
    onVacation: boolean;
    typeDescription: string;
    attendanceDescription: string;
    about: AdvisorAbout;
    whatsapp: AdvisorLink;
    calendly: AdvisorLink;
}

